interface ProviderProfileTab {
  id: string;
  title: string;
}

interface ProviderProfileTabsProps {
  activeTab: string;
  onTabChange: (id: string) => void;
  tabs: ProviderProfileTab[];
}

/**
 * Pill-style tab bar inside a white rounded container.
 * Active tab is solid navy; inactive tabs are plain gray text.
 */
const ProviderProfileTabs = ({
  activeTab,
  onTabChange,
  tabs,
}: ProviderProfileTabsProps) => (
  <div className="mt-6 overflow-x-auto rounded-2xl border border-border bg-white p-1.5">
    <div
      role="tablist"
      aria-label="Provider profile sections"
      className="flex min-w-max items-center gap-1"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            id={`provider-tab-${tab.id}`}
            aria-selected={isActive}
            aria-controls={`provider-tabpanel-${tab.id}`}
            onClick={() => onTabChange(tab.id)}
            className={`cursor-pointer whitespace-nowrap rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brandcyan focus-visible:ring-offset-2 motion-reduce:transition-none ${
              isActive
                ? 'bg-brandnavy text-white'
                : 'text-gray-600 hover:bg-brandpalecyan/20 hover:text-brandnavy'
            }`}
          >
            {tab.title}
          </button>
        );
      })}
    </div>
  </div>
);

export default ProviderProfileTabs;
